module.exports = __webpack_public_path__ + "assets/img/6-b.0cf02b6f.png";